module.exports = __webpack_public_path__ + "img/IMG_2480.8f247192.jpg";